/**
 * KikiStyle Instagram Feed
 * Fetches and displays Instagram posts from API with zero layout shift
 */
(function () {
  'use strict';

  // Instagram icon SVG for overlay
  const instagramIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  `;

  /**
   * Initialize Instagram feed for a section
   */
  function initInstagramFeed(section) {
    const apiUrl = section.dataset.apiUrl;
    const limit = section.dataset.limit || 12;
    const apiGrid = section.querySelector('.kikistyle-instagram-grid--api');
    const fallbackGrid = section.querySelector('.kikistyle-instagram-grid--fallback');

    // If no API URL configured, keep fallback visible
    if (!apiUrl || !apiGrid) {
      return;
    }

    // Fetch Instagram posts from API
    fetch(`${apiUrl}?limit=${limit}`)
      .then(response => response.json())
      .then(data => {
        if (!data.success || !data.posts || data.posts.length === 0) {
          throw new Error('No posts available');
        }

        // Render posts to API grid
        apiGrid.innerHTML = data.posts.map(post => {
          const caption = post.caption || '';
          const truncatedCaption = caption.length > 100 ? caption.substring(0, 100) + '...' : caption;

          return `
            <a
              href="${post.permalink}"
              class="kikistyle-instagram-item"
              target="_blank"
              rel="noopener noreferrer"
              title="${truncatedCaption || 'View on Instagram'}"
            >
              <img
                src="${post.mediaUrl}"
                alt="${truncatedCaption || 'Instagram post'}"
                class="kikistyle-instagram-item__img"
                loading="lazy"
              />
              <span class="kikistyle-instagram-item__overlay">
                <span class="kikistyle-instagram-item__icon">
                  ${instagramIcon}
                </span>
              </span>
            </a>
          `;
        }).join('');

        // Add loaded class to show API grid and hide fallback (CSS handles the transition)
        apiGrid.classList.add('is-loaded');
      })
      .catch(() => {
        // On error, fallback stays visible - no action needed
      });
  }

  // Initialize all Instagram sections on page
  function init() {
    const sections = document.querySelectorAll('.kikistyle-instagram');
    sections.forEach(initInstagramFeed);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.kikistyle-instagram');
    if (section) {
      initInstagramFeed(section);
    }
  });
})();
